import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import styles from "./EditNotificationMiner.module.scss";
import { MODALS_ENUM } from "@constants/Modals";
import { Button, Divider } from "antd";
import { Input } from "@components/global/new/Input/Input";
import { Select } from "@components/global/new/Select/Select";

type EditNotificationMinerProps = CommonModalPropsI & {
  minerId: string;
};

function EditNotificationMiner(props: EditNotificationMinerProps) {
  return <div className={styles.wrapper}>
    <h4 className={styles.title}>
      <span>{props.formatMessage({ id: "modal.editNotificationMiner.title" })}</span>
      <span> [{props.minerId}]</span>
    </h4>
    <Divider className={styles.divider} />
    <div className={styles.content}>
      <Select
        outlined
        label={<span className={styles.label}>
          {props.formatMessage({ id: "modal.editNotificationMiner.title.selectGroup" })}
        </span>}
      />
      <div>
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationMiner.title.hashrateBelow" })}
          </span>}
          addonAfter="%"
        />
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationMiner.title.from" })}
          </span>}
          addonAfter="TH/s"
        />
      </div>
      <Input
        outlined
        label={<span className={styles.label}>
          {props.formatMessage({ id: "modal.editNotificationMiner.title.rejects" })}
        </span>}
        addonAfter="%"
      />
    </div>
    <Divider className={styles.divider} />
    <div className={styles.buttons}>
      <Button type="primary" onClick={props.handleClose}>{props.formatMessage({ id: "modal.editNotificationMiner.buttons.save" })}</Button>
      <Button onClick={props.handleClose}>{props.formatMessage({ id: "modal.editNotificationMiner.buttons.cancel" })}</Button>
    </div>
  </div>
}

export default WithModal(MODALS_ENUM.EDIT_NOTIFICATION_MINER, EditNotificationMiner);
